import { createContext } from 'react';

import type { IAppContext, IAppContextDispatch } from './types';

export const appContext = {};

export const AppContext = createContext<IAppContext>(appContext);

export const AppContextDispatch = createContext<IAppContextDispatch>(() => {});